import React, { useState } from "react";
import Eye from "../../../../images/eye.svg";
import EyeSlash from "../../../../images/eye-slash.svg";
import XIcon from "../../../../images/XIcon.svg";
import CheckIcon from "../../../../images/CheckIcon.svg";
import PendingIcon from "../../../../images/PendingIcon.svg";
import "./KYCItem.scss";
import { Box, Typography, Button } from "@mui/material";

function KYCItem({
  docType,
  status,
  onAccept,
  onReject,
  onPending,
  isSelected,
  onSelect,
  isVisible,
  isSelect,
  isReject,
  isEyeSlash,
  setIsEyeSlash,
  docname,
  uploadLoading
}) {
  const [stateOfButton, setStateOfButton] = useState({
    accept: false,
    reject: false,
    pending: false
  })

  const getIcon = () => {
    switch (status) {
      case "Accepted":
        return <img src={CheckIcon} className="status-icon" alt="status" loading="lazy" />;
      case "Rejected":
        return <img src={XIcon} className="status-icon" alt="status" loading="lazy" />;
      case "Pending":
        return <img src={PendingIcon} className="status-icon" alt="status" loading="lazy" />;
      default:
        return null;
    }
  };

  const pendingButtonClass =
    status === "Pending" ? "status-button pending" : "status-button";
  const acceptedButtonClass =
    status === "Accepted" ? "status-button accepted" : "status-button";
  const rejectedButtonClass =
    status === "Rejected" ? "status-button rejected" : "status-button";
  const eyeBackground = isEyeSlash ? "eye-button.slash" : "eye-button";

  const toggleEyeIcon = () => {
    setIsEyeSlash(docname);
    onSelect();
  };

  console.log(docType)

  return (
    <Box>
      <Box className="kyc-item">
        <Box className="kyc-input">
          <Typography variant="h9" className="classification">Classification</Typography>
          <Box 
            className="kyc-type"
            sx={{
              width: "180px",
              height: "35px",
              flexShrink: 0,
              borderRadius: "4px",
              border: "1px solid #D6E1E6",
            }}
          >
            <Typography 
              variant="h9" 
              className="docType"
              sx={{
                color: "#000",
                fontFamily: "Inter",
                fontSize: "12px",
                fontStyle: "normal",
                fontWeight: 400,
                lineHeight: "40px",
                paddingLeft: "16px",
                paddingTop: "6px",
                paddingBottom: "6px",
              }}
            >
              {docType}
            </Typography>
          </Box>
        </Box>
        <Button className={eyeBackground} onClick={toggleEyeIcon} value={isSelect}>
          {isEyeSlash ? (
            <img src={EyeSlash} alt="View" className="eye-icon-slash" loading="lazy" />
          ) : (
            <img src={Eye} alt="View" className="eye-icon" style={{ filter: "invert(1)" }} loading="lazy" />
          )}
        </Button>
        <Button 
          className={pendingButtonClass} 
          onClick={() => {
            setStateOfButton({
              ...stateOfButton,
              pending: true
            })
            onPending();
          }} 
          sx={{ textTransform: "capitalize" }} 
          disabled={uploadLoading}
        >
          {uploadLoading && stateOfButton.pending ? "Pending..." : "Pending"}
        </Button>

        <Button 
          className={acceptedButtonClass} 
          onClick={() => {
            setStateOfButton({
              ...stateOfButton,
              accept: true
            })
            onAccept();
          }} 
          sx={{ textTransform: "capitalize" }} 
          disabled={uploadLoading}
        >
          {uploadLoading && stateOfButton.accept ? "Accepting..." : "Accept"}
        </Button>

        <Button 
          className={rejectedButtonClass} 
          onClick={onReject} 
          sx={{ textTransform: "capitalize" }} 
          disabled={uploadLoading}
        >
        {uploadLoading || isReject ? (
        <Box 
          sx={{ 
            display: "flex", 
            alignItems: "center", 
            gap: "8px" 
          }}
        >
          Rejecting...
        </Box>
      ) : (
        <>
          Reject
        </>
      )}
        </Button>
        <Box className="status-container">
          <Typography 
            variant="h9" 
            sx={{
              color: "#7E92A2",
              fontFamily: "Nunito",
              fontSize: "12px",
              fontStyle: "normal",
              fontWeight: 500,
              lineHeight: "187.5%"
            }}
          >
            Status:
          </Typography>
          <Typography 
            variant="h9" 
            sx={{
              marginLeft: "6px",
              fontSize: "12px",
            }}
          >
            {status}
          </Typography>
          {getIcon()}
        </Box>
      </Box>
    </Box>
  );
}

export default KYCItem;
